var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "120px",
    height: "120px",
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "set6/icn_fail") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "32.2679924%",
    x2: "12.6904297%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0262E9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0054AE",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-854.000000, -318.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26",
    transform: "translate(854.000000, 318.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60,0 C26.9139844,0 0,26.9139844 0,60 C0,93.0860156 26.9139844,120 60,120 C93.0860156,120 120,93.0860156 120,60 C120,26.9139844 93.0860156,0 60,0 Z",
    id: "Shape",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2754452,35.8439865 L59.999,54.12 L41.7245656,35.8439973 C40.0985397,34.2186988 37.4696403,34.2186988 35.8443863,35.8439865 L35.6872156,36.0097787 C34.2202895,37.6433718 34.272685,40.1532203 35.8445519,41.7243839 L54.119,60 L35.8443755,78.2765154 C34.2184827,79.9016807 34.2184827,82.5315603 35.8445519,84.156902 C36.6329133,84.9460211 37.6897669,85.375 38.7844706,85.375 L39.0183228,85.3684616 C40.028425,85.3119031 40.9914945,84.8898121 41.7245548,84.1567365 L59.999,65.88 L78.2754452,84.1567365 C79.0648948,84.9462025 80.1211005,85.375 81.2155295,85.375 C82.3099583,85.375 83.3661638,84.9462026 84.1556136,84.1567366 L84.3127843,83.9909444 C85.7797105,82.3573512 85.727315,79.8475027 84.1554481,78.2763391 L65.88,60 L84.1556245,41.7242076 C85.7815173,40.0990422 85.7815173,37.4691626 84.1554481,35.8438209 C82.5303321,34.2186712 79.9007267,34.2186712 78.2754452,35.8439865 Z",
    id: "Path",
    fill: "#FFFFFF"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.36a8825e.svg";
export { ForwardRef as ReactComponent };